import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@bijie/react-bnb';
import EmailVerifyWithResend from './EmailVerifyWithResend';
import { StoreContext } from './context';
import { getLabel } from '../../utils/i18n';

const Container = styled.div`
  text-align: center;
  .flex-box {
    display: flex;
    width: 550px;
    margin: 0 auto;
  }
  .left-box {
    align-self: flex-start;
    padding-right: 35px;
    img {
      width: 105px;
      height: 105px;
    }
  }
  .right-box {
    flex: 1;
    padding-bottom: 40px;
  }
  p {
    margin-bottom: 25px;
    font-size: 16px;
  }
  ul {
    padding-top: 15px;
    color: #848E9C;
    text-align: left;
    li {
      padding-bottom: 20px;
    }
  }
  .btn-box {
    padding-top: 10px;
    text-align: right;
  }
  .ragular {font-family: ${({ theme }) => theme.fontIBMRegular};}
`;

const IdVerification = ({ config: { uploadUrl } }) => {
  const { i18n } = useContext(StoreContext);
  if (!uploadUrl) {
    return (
      <EmailVerifyWithResend
        title={getLabel('exchange-reset2fa-verifyemail', i18n)}
        desc={getLabel('exchange-reset2fa-jumioemail', i18n)}
      />
    );
  }
  const gotoNextStep = () => {
    window.location.href = uploadUrl;
  };
  return (
    <Container>
      <h1 className="sub-title">{getLabel('exchange-reset2fa-idverification', i18n)}</h1>
      <p className="ragular">{getLabel('exchange-reset2fa-idtip', i18n)}</p>
      <div className="flex-box">
        <div className="left-box"><img src={require('../../static/images/2fa/kyc.svg')} alt="" /></div>
        <div className="right-box ragular">
          <ul>
            <li>{getLabel('exchange-reset2fa-idtip1', i18n)}</li>
            <li>{getLabel('exchange-reset2fa-idtip2', i18n)}</li>
          </ul>
        </div>
      </div>
      <div className="btn-box">
        <Button
          size="lg"
          type="primary"
          onClick={gotoNextStep}
        >
          {getLabel('exchange-reset2fa-next', i18n)}
        </Button>
      </div>
    </Container>
  );
};
IdVerification.propTypes = {
  config: PropTypes.object,
};

export default IdVerification;
